
import { RequestDetailEdit } from '../../../models/requestDetailEdit';

export class ShipmentMaterialEditController implements ng.IController {
    static $inject = ['$mdMedia'];

    constructor(private _$mdMedia: angular.material.IMedia) {

    }

    requestDetailEdit : RequestDetailEdit;
    
    isMaterialsValid: boolean;
    isPackagesValid: boolean;
    isAssignMaterialsToPackagesValid: boolean;

    $onInit() { }

    get isSubScrollContainer(): boolean {
        return this._$mdMedia('gt-md');
    }

    get isScrollContainer(): boolean {
        return this._$mdMedia('sm') || this._$mdMedia('md');
    }

    get isValid(): boolean {
        return this.isMaterialsValid && this.isPackagesValid && this.isAssignMaterialsToPackagesValid;
    }

    set isValid(val: boolean) { }
}


/** WEBPACK FOOTER **
 ** ./DeliveryCreate/UI/app/features/request/requestDetailEdit/directives/shipmentMaterialEdit/controllers/shipmentMaterialEditController.ts
 **/